import useFetchTriggerOptions from 'components/domain/automation/triggers/useFetchTriggerOptions';
import MultiSelectField, {
  MultiSelectFieldProps,
} from 'components/forms/multiSelectField/MultiSelectField';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'utils/arrayUtils';

interface TemplateMultiSelectFieldProps
  extends Omit<MultiSelectFieldProps, 'fieldRenderer' | 'options'> {}

const TemplateMultiSelectField = ({
  ...rest
}: TemplateMultiSelectFieldProps) => {
  const { t } = useTranslation();
  const { data, isLoading } = useFetchTriggerOptions();

  const templates = [
    ...(data?.option.smsTemplates ?? []),
    ...(data?.option.whatsAppTemplates ?? []),
    ...(data?.option.emailTemplates ?? []),
  ].map((template) => {
    return {
      label: template.name,
      value: template.uid,
    };
  });

  const options = orderBy(templates, [{ field: 'label', order: 'asc' }]);

  if (isLoading) return <LoadingPlaceholder />;

  return (
    <MultiSelectField
      colSmInput={8}
      colSmLabel={4}
      isSelectAllEnabled
      label={t('pageAutomations.triggers.filters.templateUids')}
      options={options}
      {...rest}
    />
  );
};

export default TemplateMultiSelectField;
